import { useMemo } from "react"

const useSomeSelected = (obj: Record<string, string>) => {
	return useMemo(() => {
		return obj && Object.values(obj).some(Boolean);
	}, [obj]);
}

export default useSomeSelected;